import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import Resumen from './components/Resumen/Resumen';
import Historico from './components/Historico/Historico';
import './General.scss';
import { LocalSession } from '../../../../../../types/LocalSession';

interface GeneralProps {
  billsList: any[]; // Puedes reemplazar con el tipo específico BillType[] si lo tienes
  setBillsList: React.Dispatch<React.SetStateAction<any[]>>;
  globalCategoriesList: any[]; // Lista de categorías globales
  localCategoriesList: any[];  // Lista de categorías locales
  setLocalCategoriesList: React.Dispatch<React.SetStateAction<any[]>>;
  fetchBills: () => void; // Función para obtener las facturas
  localSession?: LocalSession | null; // Sesión local opcional
}

const General: React.FC<GeneralProps> = ({
  billsList,
  setBillsList,
  globalCategoriesList,
  localCategoriesList,
  setLocalCategoriesList,
  fetchBills,
  localSession
}) => {
  const [activeTab, setActiveTab] = useState<'resumen' | 'historico'>('resumen');

  const handleShowResumen = () => setActiveTab('resumen');
  const handleShowHistorico = () => setActiveTab('historico');

  // Encabezado con botones para cambiar de tab
  const renderHeader = () => (
    <div className="mp-button-selector-page-container">
      <div className="mp-button-selector-page-selector">
        <Button
          onClick={handleShowResumen}
          variant='none'
          className={`mp-button-selector-page-button ${activeTab === 'resumen' ? 'active' : 'inactive'}`}
        >
          Resumen
        </Button>
        <Button
          onClick={handleShowHistorico}
          variant='none'
          className={`mp-button-selector-page-button ${activeTab === 'historico' ? 'active' : 'inactive'}`}
        >
          Histórico
        </Button>
      </div>
    </div>
  );

  return (
    <div className="general-container">
      {renderHeader()}
      <div className="general-content">
        {activeTab === 'resumen' && (
          <Resumen 
            billsList={billsList} 
            setBillsList={setBillsList} 
            globalCategoriesList={globalCategoriesList} 
            localCategoriesList={localCategoriesList} 
            setLocalCategoriesList={setLocalCategoriesList}
            fetchBills={fetchBills}
          />
        )}
        {activeTab === 'historico' && (
          <Historico
            globalCategoriesList={globalCategoriesList}
            localCategoriesList={localCategoriesList}
            fetchBills={fetchBills}
            lastSession={localSession}
          />
        )}
      </div>
    </div>
  );
};

export default General;
